import { render, staticRenderFns } from "./TelemedicineConsultations.vue?vue&type=template&id=b0015b04&scoped=true&"
import script from "./TelemedicineConsultations.vue?vue&type=script&lang=js&"
export * from "./TelemedicineConsultations.vue?vue&type=script&lang=js&"
import style0 from "./TelemedicineConsultations.vue?vue&type=style&index=0&id=b0015b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0015b04",
  null
  
)

export default component.exports